import React from 'react'
import { Input, Card, Flex, Divider } from 'antd'
import { useIntl, FormattedMessage } from 'react-intl'

const FaultSelect = ({ setFault, suggestedOptions, allOptions }) => {
  return (
    <Flex vertical gap="small" data-testid="fault-reasons">
      {suggestedOptions.map((option) => (
        <Card
          hoverable
          key={option.value}
          onClick={() => setFault(option.value, option)}
        >
          {option.label}
        </Card>
      ))}
      {suggestedOptions.length > 0 && <Divider />}
      {allOptions.map((option) => (
        <Card
          hoverable
          size="small"
          key={option.value}
          onClick={() => setFault(option.value)}
        >
          {option.label}
        </Card>
      ))}
    </Flex>
  )
}

const FaultComment = ({ fault, setComment, comment, options }) => {
  const { TextArea } = Input
  const [selectedOption, setSelectedOption] = React.useState(null)
  React.useEffect(() => {
    const found = options.find((opt) => opt.value === fault)
    if (found) {
      setSelectedOption(found.label)
    } else {
      setSelectedOption(fault)
    }
  }, [fault, options])
  const intl = useIntl()

  return (
    <Flex vertical gap="small">
      <div>
        <FormattedMessage id="tracer.logFailure.selectedCause" />
      </div>
      <Card size="small">{selectedOption}</Card>
      <div>
        <FormattedMessage id="tracer.logFailure.commentLabel" />
      </div>
      <TextArea
        id="comment"
        rows={6}
        value={comment}
        placeholder={intl.formatMessage({
          id: 'tracer.logFailure.commentPlaceholder',
        })}
        onChange={(e) => setComment(e.target.value)}
      />
    </Flex>
  )
}

const FaultCards = ({ options, setComment, comment, fault, setFault }) => {
  const { allOptions, suggestedOptions } = options
  return fault ? (
    <FaultComment
      options={allOptions}
      comment={comment}
      fault={fault}
      setComment={setComment}
    />
  ) : (
    <FaultSelect
      suggestedOptions={suggestedOptions}
      allOptions={allOptions}
      setFault={setFault}
    />
  )
}

export default FaultCards
